/**
 *
 * ColumnSetting
 *
 */

/* eslint-disable react/destructuring-assignment */

import { Button, Checkbox, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import SaveIcon from '@material-ui/icons/Save'
/* eslint-disable react/jsx-key */
import classNames from 'classnames/bind'
import React from 'react'

const styles = theme => ({
  headers: {
    borderBottom: '1px solid #ccc',
    margin: `${theme.spacing.unit} 0`,
    // padding: `${theme.spacing.unit} 0`,
  },
  border: {
    borderBottom: '1px solid #ccc',
    margin: `${theme.spacing.unit} 0 0`,
    // padding: `${theme.spacing.unit} 0 0 0`,
    '&:nth-last-child(2)': {
      // borderBottom: '1px solid #ccc',
      // padding: `${theme.spacing.unit} 0`,
    },
    '&:hover': {
      // background: '#ccc',
    },
  },
  leftItem: {
    display: 'flex',
    alignItems: 'center',
  },
  alignRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: `${theme.spacing.unit} 0`,
    // padding: `${theme.spacing.unit} 0`,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
})
/* eslint-disable react/prefer-stateless-function */
class ColumnSetting extends React.PureComponent {
  constructor(props) {
    super(props)
    const { json } = props
    this.state = {
      json: json.length > 0 ? json : [],
    }
    this.dragIndex = null
    this.dragOverIndex = null
  }

  // eslint-disable-next-line no-return-assign
  dragStart = key => (this.dragIndex = key)

  dragEnd = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const json = Object.assign([], this.state.json)
    const dragElement = json[this.dragIndex]
    json[this.dragIndex] = json[this.dragOverIndex]
    json[this.dragOverIndex] = dragElement
    this.setState({ json })
  }

  dragOver = key => {
    if (this.dragOverIndex !== key) this.dragOverIndex = key
  }

  isChecked = (key, isVisible) => {
    const { json } = this.state
    json[key].isVisible = isVisible
    this.setState({ json })
  }

  onApply = () => this.props.updatedJson(this.state.json)

  onCancel = () => {
    const { json, updatedJson } = this.props
    this.setState({ json })
    updatedJson(json)
  }

  render() {
    const { classes, headers } = this.props
    const { json } = this.state
    return (
      <div className={classes.dragOverDiv}>
        <Grid item>
          <Grid item xs={12}>
            <Grid container className={classes.headers}>
              {headers.length > 0 &&
                headers.map(header => (
                  // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                  <Grid item style={{ width: header.width }}>
                    {header.label}
                  </Grid>
                ))}
            </Grid>
            {json.length > 0 &&
              json.map((item, key) => (
                // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                <Grid
                  container
                  className={classNames(classes.border, 'topDiv')}
                  data-id={`playerPositions_${key}`}
                  draggable="true"
                  onDragEnd={() => {
                    this.dragEnd()
                  }}
                  onDragStart={e => {
                    this.dragStart(key, e)
                  }}
                  onDragOver={e => {
                    this.dragOver(key, e)
                  }}
                >
                  <Grid style={{ width: headers[0].width }} />
                  <Grid style={{ width: headers[1].width }}>{item.label}</Grid>
                  <Grid style={{ width: headers[2].width }}>
                    <Checkbox
                      defaultChecked={json[key].isVisible}
                      disabled={item.isDisable}
                      onChange={(evt, isVisible) => this.isChecked(key, evt, isVisible)}
                    />
                  </Grid>
                </Grid>
              ))}
          </Grid>
          <Grid container className={classes.footer}>
            <Grid>
              <Button variant="contained" color="primary" className={classes.button} onClick={this.onApply}>
                <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                Apply
              </Button>
            </Grid>
            <Grid>
              <Button variant="contained" size="small" className={classes.button} onClick={this.onCancel}>
                <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  }
}

ColumnSetting.defaultProps = {}

export default withStyles(styles)(ColumnSetting)
